import React from 'react';
import PropTypes from 'prop-types';

import Button from '../Button';

import './styles.css';

function Form({
  customStyles, className, actionBarClassName, onSubmit, submitText, invalid, children, ...props
}) {
  const submit = (e) => {
    e.preventDefault();
    onSubmit(e);
  };

  return (
    <form
      className={`Form ${className || ''}`}
      onSubmit={submit}
      style={{ ...customStyles }}
      {...props}
    >
      {children}
      <div className={`Form__action-bar ${actionBarClassName || ''}`}>
        <Button
          disabled={invalid}
          skin="primary"
          type="submit"
          text={submitText}
        />
      </div>
    </form>
  );
}

Form.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  submitText: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default Form;
